import React from "react";

// Bracket-cornered HUD panel wrapper used across pages.
export default function HUDFrame({ children, className = "", padding = "p-6 md:p-8", ...rest }) {
  return (
    <div className={`hud-frame ${padding} ${className}`} {...rest}>
      <span className="hud-c3" />
      <span className="hud-c4" />
      {children}
    </div>
  );
}
